module.exports = __webpack_public_path__ + "static/media/menu_eva_2.2c24eb40.jpg";